import { useEffect } from 'react';
// mantine
import { Button } from '@mantine/core';
// icons
import { Upload } from 'lucide-react';
// utils
import { TPersona } from '@newo/api/gateway';
import { download } from '@newo/toolkit/file';
import { tzDatetime } from '@/modules/DateTime/utils';
import { useExportAKBMutation } from '@/services/akb/akb.queries.ts';

interface ExportAKBButtonProps {
    className?: string;
    persona?: TPersona;
    isDisabled?: boolean;
}

const ExportAKBButton = ({
    className,
    persona,
    isDisabled
}: ExportAKBButtonProps) => {
    const { mutate: exportAKB, data: akb, isPending } = useExportAKBMutation();

    useEffect(() => {
        if (akb) {
            const filename = `akb-${persona?.name}-${tzDatetime().toFormat('yyyy-LL-dd')}.json`;
            const content = JSON.stringify(akb);
            download(content, filename, 'application/json;charset=utf-8;');
        }
    }, [akb, persona?.name]);

    return (
        <Button
            className={className}
            disabled={isDisabled}
            leftSection={<Upload />}
            loading={isPending}
            variant="default"
            onClick={() => {
                exportAKB({ persona_id: persona?.id ?? '' });
            }}
        >
            Export AKB
        </Button>
    );
};

export default ExportAKBButton;
